import React from 'react';
import { CursorOption } from 'js/types';
import IconIndeterminate from 'js/shared/icons/IconIndeterminate';
import IconNoAnimation from 'js/shared/icons/IconNoAnimation';
import { NO_CURSOR_ID } from 'js/config/consts';

import { ChoiceButtonIcon } from '../ChoiceButtonIcon';

export const getCursorIcon = (cursor?: CursorOption) => {
  if (!cursor) {
    return <IconIndeterminate />;
  }

  if (cursor.id === NO_CURSOR_ID || !cursor.resources) {
    return <IconNoAnimation />;
  }

  return <ChoiceButtonIcon imgUrl={cursor.resources.thumbnail.url} isPen={cursor.group === 'pens'} />;
};
